import { css } from 'aphrodite';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Checkbox, Popup, Table } from 'semantic-ui-react';

import { RootState } from '../../../application/store';
import { User } from '../../../model/User';
import HoverablePopup from '../../common/HoverablePopup';
import CopyableText from '../../common/text/CopyableText';
import { EllipsisText } from '../../common/text/EllipsisText';
import stylesCommons from '../../StylesCommons';
import { selectUsers, unselectUsers } from '../reducer.Users';

interface UserListRowProp {
    user: User;
}

const getUserType = (user: User) => {
    return user.ldapId ? 'Active Directory' : 'External User';
};

const getActivityStatus = (user: User) => {
    return user.status;
};

function UserListRow(userListRowProp: UserListRowProp) {
    const dispatch = useDispatch();
    const user = userListRowProp.user;
    const isChecked = useSelector(
        (state: RootState) => !!_.find(state.persistedReducers.users.userList.selectedUsers, user),
    );
    const userType = getUserType(user);
    const activityStatus = getActivityStatus(user);

    return (
        <Table.Row positive={isChecked}>
            <Table.Cell>
                <Popup
                    content={'Cannot perform any action on Active Directory users'}
                    disabled={!user.ldapId}
                    trigger={
                        <Checkbox
                            onChange={(event, data) => {
                                if (data.checked) {
                                    dispatch(selectUsers([user]));
                                } else {
                                    dispatch(unselectUsers([user]));
                                }
                            }}
                            checked={isChecked}
                            disabled={!!user.ldapId}
                        />
                    }
                />
            </Table.Cell>
            <Table.Cell>{user.legacyId}</Table.Cell>
            <Table.Cell>
                <HoverablePopup
                    trigger={<EllipsisText text={user.idpId} length={6} />}
                    flowing
                    hoverable>
                    <CopyableText text={user.idpId} textToCopy={user.idpId} />
                </HoverablePopup>
            </Table.Cell>
            <Table.Cell>
                <HoverablePopup
                    trigger={<EllipsisText text={user.ldapId} length={6} />}
                    flowing
                    hoverable>
                    <CopyableText text={user.ldapId} textToCopy={user.ldapId} />
                </HoverablePopup>
            </Table.Cell>
            <Table.Cell>{user.username}</Table.Cell>
            <Table.Cell>{user.firstName}</Table.Cell>
            <Table.Cell>{user.lastName}</Table.Cell>
            <Table.Cell>{user.email}</Table.Cell>
            <Table.Cell>{userType}</Table.Cell>
            <Table.Cell>{activityStatus}</Table.Cell>
            <Table.Cell>
                <Link
                    to={`/users/${user.idpId}/edit?tab=details`}
                    className={css(stylesCommons.link)}>
                    {'Details/Edit'}
                </Link>
            </Table.Cell>
        </Table.Row>
    );
}

export default UserListRow;
